'use client';
import { Builder } from '@builder.io/react';
// Product
import { PLPBreadcrumbs } from 'components/global/plp-breadcrumbs';
import { ProductGridWrap } from 'components/searchspring/Grid/ProductGrid';
import ProductCount from 'components/searchspring/Grid/ResultsCount';
import { Sidebar } from 'components/searchspring/Grid/Sidebar';
import { SortBy } from 'components/searchspring/SortBy/SortBy';
// Global Product Card
import { SearchspringWrap } from 'components/searchspring/searchspring-wrapper';

Builder.register('insertMenu', {
  models: ['search', 'category', 'blog-category'],
  name: 'PLP Components',
  items: [
    { name: 'PLP Breadcrumbs' },
    { name: 'Searchspring' },
    { name: 'Sidebar' },
    { name: 'Products Count' },
    { name: 'ProductGrid' },
    { name: 'SortBy' }
  ],
  priority: 3,
});

Builder.registerComponent(SortBy, {
  models: ['search', 'category', 'blog-category'],
  name: 'SortBy',
  friendlyName: 'Searchspring SortBy'
})

Builder.registerComponent(ProductGridWrap, {
    models: ['search', 'category', 'blog-category'],
    name: 'ProductGrid',
    friendlyName: 'Searchspring Grid',
    inputs: [
      {
        name: 'tileBanner',
        type: 'boolean',
        defaultValue: true,
      },
      {
        name: 'tileBurst',
        type: 'boolean',
        defaultValue: true,
      },
      {
        name: 'tileSpecs',
        type: 'boolean',
        defaultValue: true,
      },
      {
        name: 'tileTagline',
        type: 'boolean',
        defaultValue: true,
      },
      {
        name: 'tileRatings',
        type: 'boolean',
        defaultValue: true,
      },
      {
        name: 'tilePromo',
        type: 'boolean',
        defaultValue: true,
      },
      {
        name: 'tileATC',
        type: 'boolean',
        defaultValue: true,
      },
    ]
  }
)

Builder.registerComponent(ProductCount, {
    models: ['search', 'category', 'blog-category'],
    name: 'Products Count',
    friendlyName: 'Searchspring Count'
  }
)

Builder.registerComponent(Sidebar, {
    models: ['search', 'category', 'blog-category'],
    name: 'Sidebar',
    friendlyName: 'Searchspring Sidebar'
  }
)

Builder.registerComponent(PLPBreadcrumbs, {
  models: ['search', 'category', 'blog-category'],
  name: 'PLP Breadcrumbs',
});

Builder.registerComponent(SearchspringWrap, {
  models: ['search', 'category', 'blog-category'],
  name: 'Searchspring',
  friendlyName: 'Search & Grid',
  inputs: [
    {
      name: 'tileBanner',
      type: 'boolean',
      defaultValue: true,
    },
    {
      name: 'tileBurst',
      type: 'boolean',
      defaultValue: true,
    },
    {
      name: 'tileSpecs',
      type: 'boolean',
      defaultValue: true,
    },
    {
      name: 'tileTagline',
      type: 'boolean',
      defaultValue: true,
    },
    {
      name: 'tileRatings',
      type: 'boolean',
      defaultValue: true,
    },
    {
      name: 'tilePromo',
      type: 'boolean',
      defaultValue: true,
    },
    {
      name: 'tileATC',
      type: 'boolean',
      defaultValue: true,
    },
  ]
}
)